export default __webpack_public_path__ + "static/media/photos.b3b2bdd4.svg";